import styled from 'styled-components'

export const Box = styled.div`
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 28px;
  padding-bottom: 32px;
`
